import React, { useState } from 'react';
import { useTheme } from '../hooks/useTheme';
import { LineIcon } from './icons';
import { cx } from '../utils/cx';
import styles from './ThemeToggle.module.css';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const [spin, setSpin] = useState(false);
  const isLight = theme === 'light';

  const handleClick = () => {
    toggle();
    setSpin(true);
    setTimeout(() => setSpin(false), 30);
  };

  return (
    <button
      className={cx(styles.themeBtn, spin && styles.spin)}
      onClick={handleClick}
      aria-label="Toggle light / dark theme"
    >
      <LineIcon name="moon" className={cx(styles.moon, isLight && styles.hidden)} />
      <LineIcon name="sun" className={cx(styles.sun, !isLight && styles.hidden)} />
    </button>
  );
}
